import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'translateArray' })
export class TranslateArrayPipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform(arr: string[]): string[] {
        if (!Array.isArray(arr) || arr.length === 0) {
            return [];
        }

        return arr.map(item => this.translateService.instant(item));
    }
}
